module.exports = __webpack_public_path__ + "img/banner.2958d46.jpg";